import { render, staticRenderFns } from "./KnowledgeBaseList.vue?vue&type=template&id=356e9e89&scoped=true&"
import script from "./KnowledgeBaseList.vue?vue&type=script&lang=js&"
export * from "./KnowledgeBaseList.vue?vue&type=script&lang=js&"
import style0 from "./KnowledgeBaseList.vue?vue&type=style&index=0&id=356e9e89&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356e9e89",
  null
  
)

export default component.exports